import AbstractRequestTask from './AbstractRequestTask';
import { setHKS } from '../../utils/HKS';
class TermsTask extends AbstractRequestTask {
  constructor(params) {
    super();
    if (params.customEndPoint) {
      this.__urlDominioMicrofwk = params.customEndPoint;
      delete params.customEndPoint;
    }

    this.params = params;
  }

  getUrl() {
    const urlDominioMicrofwk = this.__urlDominioMicrofwk || `${window.getConfig.url_dominio_microfwk}services/user/settermsandconditions`;
    return urlDominioMicrofwk;
  }

  getParams() {
    const params = super.getParams();
    this.params = Object.assign(params, this.params);
    
    return params;
  }

  success(data, b) {
    const { response } = data;
    if (
      response &&
      response.userData &&
      response.userData.session_stringvalue
    ) {
      setHKS(response.userData.session_stringvalue);
    }
    const isValid = super.success(data, b);
    if (!isValid) {
        let newdata = super.parseErrors(data);
        return this.reject(newdata, b);
    }
    return this.resolve(data);
  }
}

export default TermsTask;
